import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useModals from '@hooks/useModals'
import useNumericParams from '@hooks/useNumericParams'

import PageContent from './components/PageContent'

const Details = () => {
  const { brandId } = useNumericParams()

  const modalContext = useModals()
  const {
    callbacks: {},
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {},
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent brandId={brandId} />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Details
